module.exports = __webpack_public_path__ + "media/images/icons/flags/GD-128588d5a29ea84c9da658bd96df67e5.svg";